import { ElementType } from 'react'

import style from './EmptyInformationBlock.module.scss'

type TEmptyInformationBlock = {
  title: string
  Icon: ElementType
}
export const EmptyInformationBlock = ({
  title,
  Icon,
}: TEmptyInformationBlock) => {
  return (
    <div className={style.informationBlock}>
      <Icon color='primary' className={style.icon} />
      <span className={style.informationText}>{title}</span>
    </div>
  )
}
